import * as Sortable from '../../../components/sortable'
import * as Types from './types'

export const FETCH_FILTERS = 'FETCH_FILTERS'
export const ADD_FILTERS = 'ADD_FILTERS'
export const UPDATE_FILTER = 'UPDATE_FILTER'

export const TYPE_INCLUDED: Types.FilterType = 'whitelist'
export const TYPE_EXCLUDED: Types.FilterType = 'blacklist'

export const ALL_FILTER_TYPES: Types.FilterType[] = [
  TYPE_INCLUDED,
  TYPE_EXCLUDED,
]

export const SOURCE_GROUP: Types.SourceType = 'group'
export const SOURCE_TAG: Types.SourceType = 'tag'
export const ALL_SOURCE_TYPES: Types.SourceType[] = [
  SOURCE_GROUP,
  SOURCE_TAG,
]

export const EXCLUDED_GROUP = `${TYPE_EXCLUDED}_${SOURCE_GROUP}`
export const EXCLUDED_TAG = `${TYPE_EXCLUDED}_${SOURCE_TAG}`
export const INCLUDED_GROUP = `${TYPE_INCLUDED}_${SOURCE_GROUP}`
export const INCLUDED_TAG = `${TYPE_INCLUDED}_${SOURCE_TAG}`

export const emptyFilterState: Types.FilterState = {
  data: [],
  view: Sortable.emptyViewState,
}

export const emptyState: Types.FiltersState = {
  excluded_groups: emptyFilterState,
  excluded_tags: emptyFilterState,
  included_groups: emptyFilterState,
  included_tags: emptyFilterState,
}



// WEBPACK FOOTER //
// ./src/pages/source-config/filters/constants.ts